import React, { useState } from 'react';
import _ from 'lodash';
import { Column, Table, InfiniteLoader } from 'react-virtualized';
import 'react-virtualized/styles.css';

import NoteModal from './NoteModal';
const Api = require('./Config');

const ALL = 'All';
const YESAlert = 'Alert';
const NonAlert = 'No-Alert';
const NEED_HELP = 'Need Help';
const NO_NEED = 'No Help needed';

const NO_ACTIVITY = 'NO_ACTIVITY';
const NO_START = 'NO_START';

const MailIcon = (
  <svg height={25} width={25}>
    <g>
      <path
        style={{ fill: 'orange' }}
        d="M3,0.225h18c1.656,0,3,1.344,3,3v10c0,0.313-0.062,0.609-0.15,0.893l-2.056-1.832   c-0.451-0.457-1.358-0.662-2.078-0.369l-3.692-3.779L23,2.7L12,8.632L1,2.7l6.977,5.438l-5.77,5.906l7.037-5.025L12,10.813   l2.758-1.795l4.467,3.191c-0.451,0.366-0.725,0.922-0.725,1.531v1.043c-1.135,0.168-2.473,0.565-3.703,1.441H3   c-1.656,0-3-1.344-3-3V3.225C0,1.569,1.344,0.225,3,0.225z"
      />
      <g>
        <path
          style={{ fill: 'red' }}
          d="M20,13.741v2.434c-3.227,0-7.5,1.564-7.5,9.551c1.412-5.096,3.314-5.488,7.5-5.488v2.473    c0,0.191,0.105,0.363,0.281,0.437c0.059,0.024,0.121,0.036,0.182,0.036c0.123,0,0.244-0.048,0.334-0.139l5.016-4.504    c0.184-0.184,0.184-0.484,0-0.668l-5.016-4.465c-0.135-0.135-0.34-0.176-0.516-0.103S20,13.549,20,13.741z"
        />
      </g>
    </g>
  </svg>
);

const alertOptions = [YESAlert, NonAlert];
const helpOptions = [NEED_HELP, NO_NEED];

const EncounterList = ({
  encounters,
  allJourneyNames,
  allStatus,
  allApps,
  maxRows,
  loadMore,
  onNoteSave,
  onESViewClick,
  onMailClick,
  onPatientClick,
  onStatusChange,
  onFilterChange,
  sortState,
  listHeight,
  tableStyle,
  role,
}) => {
  const initialFilters = {
    alert: ALL,
    journey_name: ALL,
    status: ALL,
    patient_ref: '',
    group: '',
    t_code: '',
    pmhid: '',
    app: ALL,
    need_help: ALL,
  };

  const [filter, setFilter] = useState(initialFilters);
  const [noteModal, setNoteModal] = useState(false);
  const [noteModalItem, setNoteModalItem] = useState({
    PMHID: null,
    t_code: null,
  });

  /********************************************************
   * Row Item Rendering Functions
   ********************************************************/

  const getAlert = (alert, emergencyAlert, inactiveType, inactiveDays) => {
    let alertIcon = '';
    let iconStyle = { width: 20, height: 20 };

    if (alert === true) {
      if (emergencyAlert === true) {
        alertIcon = <img style={iconStyle} src={Api.getHost() + '/docportal_api/emergency.svg'} />;
      } else {
        alertIcon = <div style={{ ...iconStyle, ...{ backgroundColor: 'red', borderRadius: '50%' } }} />;
      }
    }

    if (inactiveType === NO_ACTIVITY) {
      const imageSrc = inactiveDays == 20 ? 'alert_missed_20.svg' : 'alert_missed_40.svg';
      alertIcon = <img style={iconStyle} src={Api.getHost() + '/docportal_api/' + imageSrc} />;
    }

    if (inactiveType === NO_START) {
      alertIcon = <img style={iconStyle} src={Api.getHost() + '/docportal_api/alert_nostart.svg'} />;
    }

    return alertIcon;
  };

  const getPdfLink = (PMHID, isExternal, journeyName, jid, lang) => {
    if (isExternal === 'Y') {
      return (
        <a target="_blank" href={`${Api.getHost()}docportal_api/services/get_ts_file.php?PMHID=${PMHID}`}>
          {journeyName}
        </a>
      );
    }

    return (
      <a
        style={{ cursor: 'pointer' }}
        onClick={() => {
          onESViewClick({
            title: journeyName,
            PMHID: PMHID,
            jid: jid,
            lang: lang,
          });
        }}
      >
        {journeyName}
      </a>
    );
  };

  const getBioReadings = (bioReading) => {
    if (bioReading.length == 0) return '-';
    return bioReading.map((a) => `${a.type}: ${a.value}`).join(',');
  };

  const getNeedHelpRenderer = (needHelpAnswer) => {
    if (needHelpAnswer === 'Y')
      return <i className="fa fa-exclamation-circle" style={{ color: 'red', fontSize: 16 }} />;
    if (needHelpAnswer === 'N') return <i className="fa fa-heart" style={{ color: 'green', fontSize: 16 }} />;
    return '';
  };

  const getMailRenderer = (t_code, app_code) => {
    return (
      <div
        className="btn"
        style={{ objectFit: 'contain', height: 40 }}
        onClick={() => {
          onMailClick({ t_code, app_code });
        }}
      >
        {MailIcon}
      </div>
    );
  };

  const noteRenderer = (row) => {
    return (
      <i
        onClick={() => {
          setNoteModalItem(row);
          setNoteModal(true);
        }}
        style={{ fontSize: 20, cursor: 'pointer', backgroundColor: (row.note || '').length > 0 ? 'yellow' : '#ffffff' }}
        className="fa fa fa-sticky-note-o"
      />
    );
  };

  const getStatusBox = (encounter) => {
    /*
    For CMDR Nio wants all logged in user to change the status 
    changed 9/14/2020
    if (this.state.role == 2) {
      return encounter.current_status;
    }
    */

    let filteredStatus = _.filter(allStatus, (a) => a.app_id == -1 || a.app_id == encounter.app_id);
    filteredStatus = _.map(filteredStatus, (a) => a.initials);

    return (
      <select
        onChange={(e) => {
          const { value } = e.target;
          Api.setHl7Status(encounter.PMHID, value).then(() => {
            if (onStatusChange) {
              onStatusChange(encounter.PMHID, value);
            }
          });
        }}
        value={encounter.current_status}
      >
        {filteredStatus.map((status) => (
          <option key={status} value={status}>
            {status}
          </option>
        ))}
      </select>
    );
  };

  const getPatientRef = (patientRef, patientId) => {
    if (onPatientClick) {
      return (
        <a
          style={{ cursor: 'pointer' }}
          onClick={() => {
            onPatientClick({
              ref: patientRef,
              patientId: patientId,
            });
          }}
        >
          {patientRef}
        </a>
      );
    }

    return patientRef;
  };

  const getTableCell = ({ cellData, dataKey, rowData }) => {
    if (dataKey === 'alert') {
      return getAlert(rowData.alert, rowData.emergencyAlert, rowData.inactive_type, rowData.inactive_days);
    }
    if (dataKey === 'journey_name') {
      return getPdfLink(rowData.PMHID, rowData.is_external, rowData.journey_name, rowData.jid, rowData.lang);
    }
    if (dataKey === 'bio_reading') {
      return getBioReadings(cellData);
    }
    if (dataKey === 'need_help_answer_value') {
      return getNeedHelpRenderer(rowData.need_help_answer);
    }
    if (dataKey === 'diff_date') {
      return Api.getDateFormat(rowData.t_created_date, true);
    }
    if (dataKey === 't_deleted_date') {
      return Api.getDateFormat(rowData.t_deleted_date, true);
    }
    if (dataKey === 'MSG') {
      return getMailRenderer(rowData.t_code, rowData.app_id);
    }
    if (dataKey === 'NOTE') {
      return noteRenderer(rowData);
    }
    if (dataKey === 'status') {
      return getStatusBox(rowData);
    }
    if (dataKey === 'patient_ref') {
      return getPatientRef(cellData, rowData.PID);
    }
  };

  /********************************************************
   * Row Filter Functions
   ********************************************************/

  const handleFilterChange = (field, value) => {
    let newFilter = filter;
    newFilter[field] = value;
    setFilter(newFilter);

    onFilterChange(getStateFilters());
  };

  const createCombo = (values, field, maxWidth = 260) => {
    if (values.length <= 1) {
      return;
    }

    values = [ALL, ...values];

    return (
      <select
        onClick={(ea) => {
          ea.stopPropagation();
        }}
        className="form-control"
        style={{ maxWidth, fontWeight: 'normal', fontSize: 11 }}
        onChange={(e) => {
          handleFilterChange(field, e.target.value);
        }}
      >
        {values.map((a) => (
          <option key={a} value={`${a}`}>
            {a}
          </option>
        ))}
      </select>
    );
  };

  const createTextBox = (field, length) => {
    return (
      <input
        onClick={(ea) => {
          ea.stopPropagation();
        }}
        onChange={(e) => {
          handleFilterChange(field, e.target.value);
        }}
        size={length}
        style={{ fontWeight: 'normal', fontSize: 11 }}
        className="form-control"
        type="text"
      />
    );
  };

  const getFilter = (dataKey) => {
    return (
      <div style={{ marginTop: 10, height: 30 }}>
        {dataKey === 'alert' && <div>{createCombo(alertOptions, 'alert', 50)}</div>}
        {dataKey === 'patient_ref' && <div>{createTextBox('patient_ref', 6)}</div>}
        {dataKey === 'group_name' && <div>{createTextBox('group', 6)}</div>}
        {dataKey === 't_code' && <div>{createTextBox('t_code', 6)}</div>}
        {dataKey === 'PMHID' && <div>{createTextBox('pmhid', 6)}</div>}
        {dataKey === 'journey_name' && <div>{createCombo(allJourneyNames, 'journey_name')}</div>}
        {dataKey === 'need_help_answer' && <div>{createCombo(helpOptions, 'need_help', 100)}</div>}
        {dataKey === 'status' && (
          <div>
            {createCombo(
              _.map(allStatus, (a) => a.initials),
              'status'
            )}
          </div>
        )}
        {dataKey === 'app_id' && <div>{createCombo(allApps, 'app')}</div>}
        {dataKey === 'bio_reading' && <div> </div>}
        {dataKey === 'diff_date' && <div> </div>}
        {dataKey === 't_deleted_date' && <div> </div>}
      </div>
    );
  };

  const getStateFilters = () => {
    return {
      alert: filter.alert === ALL ? null : filter.alert,
      journey_name: filter.journey_name === ALL ? null : filter.journey_name.toUpperCase(),
      status: filter.status === ALL ? null : filter.status,
      patient_ref: filter.patient_ref.toLowerCase(),
      group: filter.group.toLowerCase(),
      t_code: filter.t_code.toLowerCase(),
      pmhid: filter.pmhid,
      app: filter.app === ALL ? null : filter.app,
      need_help: filter.need_help === ALL ? null : filter.need_help,
    };
  };

  const headerRenderer = ({ dataKey, label }) => {
    const showSortIndicator = sortState.sortBy.includes(dataKey);
    return (
      <div style={{ outline: 'none' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span style={{ fontSize: 11 }} title={label}>
            {label}
          </span>
          {showSortIndicator && (
            <svg width={18} height={18} viewBox="0 0 24 24">
              {sortState.sortDirection[dataKey] === 'ASC' ? <path d="M7 14l5-5 5 5z" /> : <path d="M7 10l5 5 5-5z" />}
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
          )}{' '}
          {!showSortIndicator && (
            <span style={{ height: 18, width: 18, marginLeft: 2 }}>
              <i className="fa fa-sort"></i>
            </span>
          )}
        </div>
        {getFilter(dataKey)}
      </div>
    );
  };

  const headerRowRenderer = ({ columns }) => {
    return (
      <div
        role="row"
        style={{
          backgroundColor: '#eaeaea',
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center',
          height: 80,
          width: 1140,
          borderBottomWidth: 1,
          borderBottomStyle: 'solid',
        }}
      >
        {columns}
      </div>
    );
  };

  const getRowStyle = ({ index }) => {
    if (index % 2 == 0) return { backgroundColor: '#f0f0f0', paddingTop: 10, paddingBottom: 10 };
    return { backgroundColor: '#ffffff', paddingTop: 10, paddingBottom: 10 };
  };

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-12">
          <div className="table-responsive" style={{ width: '100%', display: 'block' }}>
            <InfiniteLoader
              isRowLoaded={({ index }) => {
                return !!encounters[index];
              }}
              loadMoreRows={loadMore}
              rowCount={parseInt(maxRows, 10)}
            >
              {({ onRowsRendered, registerChild }) => (
                <Table
                  //Infinite loader stuff
                  ref={registerChild}
                  onRowsRendered={onRowsRendered}
                  rowCount={encounters.length}
                  headerHeight={20}
                  style={{ ...{ fontSize: 11 }, ...tableStyle }}
                  width={1140}
                  height={listHeight || 800}
                  rowHeight={30}
                  headerStyle={{ outline: 'none', userSelect: 'none' }}
                  rowStyle={getRowStyle}
                  rowGetter={({ index }) => encounters[index]}
                  sort={sortState.sort}
                  headerRowRenderer={headerRowRenderer}
                >
                  <Column
                    cellRenderer={getTableCell}
                    label="Alert"
                    dataKey="alert"
                    width={60}
                    headerRenderer={headerRenderer}
                  />
                  <Column
                    label="Patient"
                    cellRenderer={getTableCell}
                    dataKey="patient_ref"
                    width={100}
                    headerRenderer={headerRenderer}
                  />
                  <Column label="Group" dataKey="group_name" width={100} headerRenderer={headerRenderer} />
                  <Column label="TCode" dataKey="t_code" width={75} headerRenderer={headerRenderer} />
                  {(role == Api.ROLE_MANAGER || role == Api.ROLE_SUPER) && (
                    <Column label="App" dataKey="app_id" width={75} headerRenderer={headerRenderer} />
                  )}
                  <Column label="PMHID" dataKey="PMHID" width={75} headerRenderer={headerRenderer} />
                  <Column
                    label="Encounter Summary"
                    cellRenderer={getTableCell}
                    dataKey="journey_name"
                    width={400}
                    headerRenderer={headerRenderer}
                  />
                  <Column
                    label="Bio Value"
                    dataKey="bio_reading"
                    cellRenderer={getTableCell}
                    width={140}
                    headerRenderer={headerRenderer}
                  />
                  <Column
                    label="Created"
                    dataKey="diff_date"
                    cellRenderer={getTableCell}
                    width={150}
                    headerRenderer={headerRenderer}
                  />
                  <Column
                    label="Transferred"
                    dataKey="t_deleted_date"
                    cellRenderer={getTableCell}
                    width={150}
                    headerRenderer={headerRenderer}
                  />
                  <Column
                    label="MSG"
                    dataKey="MSG"
                    cellRenderer={getTableCell}
                    width={100}
                    headerRenderer={headerRenderer}
                  />
                  <Column
                    label="Status"
                    dataKey="status"
                    width={150}
                    cellRenderer={getTableCell}
                    headerRenderer={headerRenderer}
                  />
                  <Column
                    label=""
                    dataKey="NOTE"
                    cellRenderer={getTableCell}
                    width={40}
                    headerRenderer={headerRenderer}
                  />
                </Table>
              )}
            </InfiniteLoader>
          </div>
        </div>
      </div>
      <NoteModal
        show={noteModal}
        PMHID={noteModalItem.PMHID}
        t_code={noteModalItem.t_code}
        onClose={(item) => {
          setNoteModal(false);
          onNoteSave(item);
        }}
      />
    </React.Fragment>
  );
};

export default EncounterList;
